
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as WarningTriangleIconComponent } from "./warning-triangle-icon.svg";

export const WarningTriangleIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <WarningTriangleIconComponent {...props} />;
};
